import { mapGetters } from 'vuex'
import paths from 'routes/paths'
import { generateSearchForm, genQueryParamsResultPage } from 'utilities/generateSearchForm'

export default {
  computed: {
    ...mapGetters({
      searchForm: 'search/getSearchForm',
      isTiersMode: 'setting/isTiersMode',
      isBrandFacility: 'setting/isBrandFacility',
      ghaQueryParams: 'search/getGHAQueryParams'
    })
  },
  methods: {
    goToSearchPage(queryParams = {}) {
      if (!this.searchForm || !this.searchForm.checkin) {
        // Generate default search form
        const defaultSearchFormData = generateSearchForm(this.searchForm || {})
        this.$store.dispatch('search/setSearchForm', defaultSearchFormData)
      }
      const query = genQueryParamsResultPage(this.searchForm, this.isTiersMode)

      // Preserve GHA query parameters if they exist
      const ghaParams = {}
      if (this.ghaQueryParams?.metasearch_source) {
        ghaParams.metasearch_source = this.ghaQueryParams.metasearch_source
      }
      if (this.ghaQueryParams?.room_type_code) {
        ghaParams.room_type_code = this.ghaQueryParams.room_type_code
      }
      if (this.ghaQueryParams?.hotel_plan_code) {
        ghaParams.hotel_plan_code = this.ghaQueryParams.hotel_plan_code
      }

      if (this.isBrandFacility) {
        this.$router.push({
          name: paths.facilities,
          query: { ...query, ...ghaParams, ...queryParams }
        })
      } else {
        this.$router.push({
          name: paths.booking.result,
          query: { ...query, ...ghaParams, ...queryParams }
        })
      }
    }
  }
}
